import React, { createContext, useContext } from 'react'
import { BillingSettingsPageLogicContract } from './BillingSettingsPageLogicContract'

const BillingSettingsPageLogicContext = createContext<BillingSettingsPageLogicContract | null>(null)

export const useBillingSettingsPageBusinessLogic = (): BillingSettingsPageLogicContract | null => {
    return useContext(BillingSettingsPageLogicContext)
}

interface ComponentProps extends React.ComponentProps<any>, BillingSettingsPageLogicContract { }

export const BillingSettingsPageBusinessLogicProvider: React.FunctionComponent<ComponentProps> = (props: React.PropsWithChildren<ComponentProps>) => {
    const { children, ...rest } = props

    return <BillingSettingsPageLogicContext.Provider value={rest}>{children}</BillingSettingsPageLogicContext.Provider>
}

